var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiTutor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tutor-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.873,
    height: 28.839,
    viewBox: "0 0 18.873 28.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2463268802528",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M9.44,9.355a26.115,26.115,0,0,1,5.007.485,1.985,1.985,0,0,1,1.6,2.043,12.033,12.033,0,0,1-.263,1.849,23.706,23.706,0,0,1-1.22,3.8,1.96,1.96,0,0,1-1.543,1.208,26.179,26.179,0,0,1-3.584.248,26.162,26.162,0,0,1-3.584-.248,1.96,1.96,0,0,1-1.543-1.208,23.69,23.69,0,0,1-1.222-3.8,12.168,12.168,0,0,1-.262-1.848,1.985,1.985,0,0,1,1.6-2.043A26.115,26.115,0,0,1,9.44,9.355Zm-.582-5.83v2.19a30.568,30.568,0,0,0-5.288.564A4.4,4.4,0,0,0,.011,10.84,15.037,15.037,0,0,0,.342,13.2a28.2,28.2,0,0,0,1.437,4.492,4.383,4.383,0,0,0,3.46,2.7,30.644,30.644,0,0,0,8.4,0,4.383,4.383,0,0,0,3.46-2.7A28.2,28.2,0,0,0,18.538,13.2a15.223,15.223,0,0,0,.331-2.356A4.4,4.4,0,0,0,15.31,6.279a30.584,30.584,0,0,0-5.288-.564V3.525a.584.584,0,0,0-.288-.5V1.457a.759.759,0,1,0-.589,0V3.023a.584.584,0,0,0-.288.5Z",
    transform: "translate(-0.004 0)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M34.624,80.186a.8.8,0,1,0-.8-.8A.8.8,0,0,0,34.624,80.186Z",
    transform: "translate(-28.582 -66.409)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M78.472,80.186a.8.8,0,1,0-.8-.8A.8.8,0,0,0,78.472,80.186Z",
    transform: "translate(-65.641 -66.409)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M27.159,128.19c-3.418,0-6.189.6-6.189,3.082a6.628,6.628,0,0,0,6.189,5.9,6.628,6.628,0,0,0,6.189-5.9C33.348,128.791,30.577,128.19,27.159,128.19Z",
    transform: "translate(-17.723 -108.335)",
    fill: "#b7b7b7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiTutor);
export default __webpack_public_path__ + "static/media/AI-tutor.23771d49f5281896a49acccbbfb374df.svg";
export { ForwardRef as ReactComponent };